import type { ReactNode } from "react";
import * as stylex from "@stylexjs/stylex";
import { fontSizes, spacing } from "@softmax/design-system/tokens.stylex";
import { onePagerLayout } from "./one-pager-layout.styles";

export function PlayOnePagerRecommendations({
  caption,
  notice,
  programs,
}: {
  readonly caption: string | null;
  readonly notice: ReactNode;
  readonly programs: readonly ReactNode[] | null;
}) {
  return (
    <>
      <div {...stylex.props(styles.recommendationTitle)}>
        <h3 {...stylex.props(onePagerLayout.headingText)}>
          Recommended programs
        </h3>
        {caption !== null ? (
          <span {...stylex.props(onePagerLayout.cardNote)}>{caption}</span>
        ) : null}
      </div>
      {notice}
      {programs !== null ? (
        <ul {...stylex.props(styles.programs)}>{programs}</ul>
      ) : null}
    </>
  );
}

const styles = stylex.create({
  recommendationTitle: {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between",
    marginTop: spacing.space12,
    marginInline: 0,
    marginBottom: spacing.space6,
    fontSize: fontSizes.small,
    fontWeight: 600,
  },
  programs: { margin: 0, padding: 0, listStyle: "none" },
});
